import React from 'react';
import { GridLayout, GridLayoutItem } from '@progress/kendo-react-layout';
import { useUIConfig } from '../UiProvider';

export const Footer: React.FC = () => {
  const { footerUrl, footerName } = useUIConfig();

  return (
    <div className="footer">
      <GridLayout
        gap={{
          rows: 1,
          cols: 2
        }}
        align={{ vertical: 'middle' }}
        className="footerGrid"
      >
        <GridLayoutItem row={1} col={1}>
          <a href={footerUrl} target="_blank" rel="noreferrer">
            {footerUrl}
          </a>
        </GridLayoutItem>
        <GridLayoutItem row={1} col={2} style={{ textAlign: 'right' }}>
          © Copyright {footerName} {new Date().getFullYear()}
        </GridLayoutItem>
      </GridLayout>
    </div>
  );
};
